jQuery(document).ready(function($) {

    function isLandscapePhone() {
        return window.innerWidth <= 1000 && window.matchMedia("(orientation: landscape)").matches;
    }

    $('#navclick').click(function(){
        $(this).toggleClass('toggled');
        $('#navContent').toggleClass('open')
    });

    function adjustPadding() {
        if (!isLandscapePhone()) {
            var menuHeight = $(".top-matter").height();
            $(".first-content").css("padding-top", menuHeight);
        } else {
            // reset in case padding was applied before rotation
            $(".first-content").css("padding-top", "");
        }
    }

    // run once on load
    adjustPadding();

    // and again on resize/orientation change
    $(window).on("resize orientationchange", function() {
        adjustPadding();
    });

});
